import React, { useState, useEffect, useContext } from "react";
import * as Component from "../../../../component";
import * as Style from "../../../../component/style/content/default";
import * as Services from "../../../../service";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import Select from "react-select";
import ModalPratinjauHtml from "./modal.pratinjauHtml"

const api = Services.api.ApiEvent.Microsite;

const ModalMicrositeCreate = (props: {
  show: Boolean,
  onHide: Function,
  dataProps: any,
}) => {
  const { htmlContentBuilder, dispatch, data_user } = useContext(
    Services.Context
  );
  const { show, onHide, dataProps } = props;
  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
    setValue,
    getValues
  } = useForm({
    defaultValues: {
      microsite_name: "",
      microsite_content: "",
      microsite_form_name: "",
      microsite_form_description: "",
      microsite_form_success_message: "",
      microsite_own_url: "",
    },
  });
  const [selected, setSelected] = useState({
    company: "",
  });
  const [options, setOptions] = useState({
    company: [],
  });
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modal_pratinjau_html, setModal_pratinjau_html] = useState(false)

  const getCompany = async () => {
    await api.getCompany().then((res) => {
      if (res.success) {
        setOptions((state) => ({
          ...state,
          company: res?.data?.map((item) => ({
            value: item.company_id,
            label: item.company_name,
          })),
        }));
      }
    });
  };

  useEffect(async () => {
    if (show) {
      await getCompany();
      dispatch({
        type: "SET_CONTENT_BUILDER",
        htmlContentBuilder: "",
      });
    }
  }, [show]);

  useEffect(() => {
    setValue("microsite_content", htmlContentBuilder);
  }, [htmlContentBuilder]);

  const BtnSubmit = async (body) => {
    try {
      body = {
        ...body,
        company_id: selected.company.value,
        user_id: data_user.id,
      };
      setLoading(true);
      await api.postMicrosite(body).then(async (res) => {
        if (res?.success) {
          await Promise.all([
            // dataProps?.getList(),
            Component.AlertSuccess({ title: "Success", text: res?.success }),
            onHide(),
            reset({}),
          ]);
        } else {
          Component.AlertError({ title: "Error", text: res?.error });
        }
      });
    } catch (err) {
      Component.AlertError({ title: "Error", text: err });
    } finally {
      setLoading(false);
    }
  };


  const BtnModalPratinjauHtml = (type) => {
    switch (type) {
      case 'open':
        setModal_pratinjau_html(true)
        break;
      case 'close':
        setModal_pratinjau_html(false)
        break;
      default:
        return null
    }
  }

  let paramsPratinjauHTML = {
    htmlContentBuilder
  }


  return (
    <Component.Modal_Component
      size="xl"
      show={show}
      onHide={onHide}
      title="Microsite"
      btnSubmit
      btnName={loading ? <Component.LoadingIcon /> : "Simpan"}
      onClick={loading ? null : handleSubmit(BtnSubmit)}
    >
      <Container>
        {/* MODAL ==== */}
        <Component.IdxContentBuilder
          show={modal}
          onHide={() => setModal(false)}
        />

        <ModalPratinjauHtml
          show={modal_pratinjau_html}
          onHide={() => BtnModalPratinjauHtml('close')}
          params={paramsPratinjauHTML}
        />
        {/* END MODAL ===== */}
        <div className="form">
          <div className="mb-3">
            <Style.Label color={Style.COLOR_SECONDARY}>
              Nama Microsite
            </Style.Label>
            <input
              type="text"
              placeholder="Masukkan Nama Microsite"
              className="form-control"
              {...register("microsite_name", { required: true })}
            />
            {errors.microsite_name && "Field is Required"}
          </div>
          <div className="mb-3">
            <Style.Label color={Style.COLOR_SECONDARY}>
              Nama Microsite
            </Style.Label>
            <div className="d-flex gap-2 mb-3">
              <Style.ButtonPrimary

                onClick={() => setModal(true)}
              >
                Buka Html Builder
              </Style.ButtonPrimary>
              {
                htmlContentBuilder !== '' ?
                  <Style.ButtonPrimary onClick={() => BtnModalPratinjauHtml('open')}>
                    Pratinjau HTML
                  </Style.ButtonPrimary>
                  : null
              }
            </div>
            <textarea
              type="text"
              placeholder="Html Builder"
              className="form-control"
              {...register("microsite_content")}
            />
          </div>
          <div className="mb-3">
            <Style.Label color={Style.COLOR_SECONDARY}>
              Nama Form Feedback / Survey
            </Style.Label>
            <input
              type="text"
              placeholder="Masukkan Nama Form Feedback / Survey"
              className="form-control"
              {...register("microsite_form_name", { required: true })}
            />
            {errors.microsite_form_name && "Field is Required"}
          </div>
          <div className="mb-3">
            <Style.Label color={Style.COLOR_SECONDARY}>
              Deskripsi Form Feedback / Survey
            </Style.Label>
            <input
              type="text"
              placeholder="Masukkan Deskripsi Form"
              className="form-control"
              {...register("microsite_form_description", { required: true })}
            />
            {errors.microsite_form_description && "Field is Required"}
          </div>
          <div className="mb-3">
            <Style.Label color={Style.COLOR_SECONDARY}>
              Pesan Berhasil / Terimakasih (Setelah user mengisi form)
            </Style.Label>
            <input
              type="text"
              placeholder="Masukkan Pesan"
              className="form-control"
              {...register("microsite_form_success_message", {
                required: true,
              })}
            />
            {errors.microsite_form_success_message && "Field is Required"}
          </div>
          <div className="mb-3">
            <Style.Label color={Style.COLOR_SECONDARY}>
              Url Kepemilikan Microsite
            </Style.Label>
            <input
              type="text"
              placeholder="Masukkan Url https://yourwebsite.com"
              className="form-control"
              {...register("microsite_own_url")}
            />
          </div>
          <div className="mb-3">
            <Style.Label color={Style.COLOR_SECONDARY}>Perusahaan</Style.Label>
            <Select
              placeholder="Select Perusahaan"
              options={options.company}
              value={selected.company}
              onChange={(e) =>
                setSelected((state) => ({ ...state, company: e }))
              }
            />
          </div>
        </div>
      </Container>
    </Component.Modal_Component>
  );
};

export default ModalMicrositeCreate;

const Container = styled.div`
  .form {
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
    color: rgba(10, 10, 10, 0.5);
    max-width: 100%;
    position: relative;
    border-radius: 10px;
  }
`;
